import _ from 'lodash'

const state = {
  travellers: [],
  searchParametersTravellers: [],
  selectedTravellers: [],
  selectedTravellersDetails: [], // TODO refacto wording
  selectedTravellersPassportDetails: [], // TODO refacto wording
  selectedTravellersDetailsValidity: [], // TODO refacto wording
  selected_luggage_option: undefined,
  contactEmail: '',
  contactEmailValidity: false,
  contactAddress: '',
  contactCity: '',
  contactZipCode: '',
  contactCountry: '',
  contactAddressValidity: false,
  phoneNumber: '',
  mobilePhoneNumber: '',
  phoneNumberValidity: false,
  finalsDetailsLoading: false
}

const mutations = {
  changeTravellers (state, newTravellers) {
    state.travellers = newTravellers
  },
  changeSearchParametersTravellers (state, newTravellers) {
    state.searchParametersTravellers = newTravellers
  },
  changeSelectedTravellers (state, newSelectedTravellers) {
    state.selectedTravellers = _.orderBy(newSelectedTravellers, ['birthday'], ['asc'])
  },
  changeSelectedTravellersDetails (state, newSelectedTravellers) {
    state.selectedTravellersDetails = newSelectedTravellers
  },
  changeSelectedTravellersPassportDetails (state, newSelectedTravellers) {
    state.selectedTravellersPassportDetails = newSelectedTravellers
  },
  changeSelectedTravellersDetailsValidity (state, newSelectedTravellers) {
    state.selectedTravellersDetailsValidity = newSelectedTravellers
  },
  changeCommonSelectedLuggageOption (state, newSelectedLuggageOption) {
    state.selected_luggage_option = newSelectedLuggageOption
  },
  changeContactEmail (state, newEmail) {
    state.contactEmail = newEmail
  },
  changeContactEmailValidity (state, newEmail) {
    state.contactEmailValidity = newEmail
  },
  changeContactAddress (state, newAddress) {
    state.contactAddress = newAddress
  },
  changeContactCity (state, newCity) {
    state.contactCity = newCity
  },
  changeContactZipCode (state, newZipCode) {
    state.contactZipCode = newZipCode
  },
  changeContactCountry (state, newCountry) {
    state.contactCountry = newCountry
  },
  changeContactAddressValidity (state, newAddressValidity) {
    state.contactAddressValidity = newAddressValidity
  },
  changePhoneNumber (state, newPhoneNumber) {
    state.phoneNumber = newPhoneNumber
  },
  changeMobilePhoneNumber (state, newPhoneNumber) {
    state.mobilePhoneNumber = newPhoneNumber
  },
  changePhoneNumberValidity (state, newValidity) {
    state.phoneNumberValidity = newValidity
  },
  changeFinalsDetailsLoading (state, newLoadingState) {
    state.finalsDetailsLoading = newLoadingState
  }
}

const getters = {
  getValidity (state) {
    const selectedTravellersDetailsValidity = _.every(state.selectedTravellersDetailsValidity, 'validity')
    return !!(selectedTravellersDetailsValidity &&
      state.contactAddressValidity &&
      state.contactEmailValidity &&
      state.phoneNumberValidity)
  }
}

const actions = {
  /**
   * Will reset the states to default except the basic search parameters
   * @param commit
   * @return null
   */
  resetStates ({ commit }) {
    commit('changeSelectedTravellers', [])
    commit('changeSelectedTravellersDetails', [])
    commit('changeSelectedTravellersPassportDetails', [])
    commit('changeSelectedTravellersDetailsValidity', [])
  },
  changeSelectedTravellersDetails ({ commit, state }, payload) {
    const newList = _.cloneDeep(state.selectedTravellersDetails)
    _.remove(newList, (o) => {
      return o.registration_number === payload.registration_number
    })
    newList.push(payload)
    commit('changeSelectedTravellersDetails', newList)
  },
  changeSelectedTravellersPassportDetails ({ commit, state }, payload) {
    const newList = _.cloneDeep(state.selectedTravellersPassportDetails)
    _.remove(newList, (o) => {
      return o.registration_number === payload.registration_number
    })
    newList.push(payload)
    commit('changeSelectedTravellersPassportDetails', newList)
  },
  changeSelectedTravellersDetailsValidity ({ commit, state }, payload) {
    const newList = _.cloneDeep(state.selectedTravellersDetailsValidity)
    _.remove(newList, (o) => {
      return o.registration_number === payload.registration_number
    })
    newList.push(payload)
    commit('changeSelectedTravellersDetailsValidity', newList)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
